import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils } from 'versafleet-core';
import classNames from 'classnames';
import TaskDriverTagForm from './taskDriverTagForm';

class ButtonTaskDriverTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
    };
    this.buttonRef = null;
    this.setButtonRef = (element) => {
      this.buttonRef = element;
    };
  }

  componentDidMount() {
    Utils.OutsideClickHandler.registerNode(this.buttonRef,
      this._setDropdown.bind(this, false));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isAddingTag && this.props.isAddingTag) {
      this._setDropdown(false);
    }
  }

  componentWillUnmount() {
    Utils.OutsideClickHandler.removeNode(this.buttonRef);
  }

  _setDropdown(isDropdown) {
    this.setState({
      dropdown: isDropdown,
    });
    if (!Utils.Helper.isNullOrUndefined(this.props.setButtonPersistent)) {
      this.props.setButtonPersistent(isDropdown);
    }
  }

  _toggleDropdown() {
    this.setState(prevState => ({
      dropdown: !prevState.dropdown,
    }));
    if (!Utils.Helper.isNullOrUndefined(this.props.setButtonPersistent)) {
      this.props.setButtonPersistent(!this.state.dropdown);
    }
  }

  _onClick() {
    this._toggleDropdown();
    const id = this.props.taskId;
    if (!Utils.Helper.isNullOrUndefined(this.props.onClick)) {
      this.props.onClick(id);
    }
  }

  _renderButton() {
    // const {text} = this.props;
    // return (
    //   <Button
    //     className={this.props.buttonClassName}
    //     iconClassName={this.props.iconClassName}
    //     iconText={this.props.iconText}
    //     onClick={this._onClick.bind(this)}
    //     text={text}
    //   />
    // );
    return (
      <Components.Button
        className={this.props.buttonClassName}
        hint={this.props.hint}
        iconClassName={this.props.iconClassName}
        iconText={this.props.iconText}
        id={this.props.id}
        onClick={() => this._onClick()}
      >
        <i className={this.props.textIconClassName} />
      </Components.Button>
    );
  }

  _renderDropdown() {
    const className = classNames('button-popup-form__form', { multi: this.props.taskId === undefined });
    if (this.state.dropdown === true) {
      return (
        <div className={className}>
          <TaskDriverTagForm
            ids={this.props.taskIds}
            loading={this.props.isAddingTag}
            tagMultiple={this.props.tagMultiple}
            tags={this.props.tags}
          />
        </div>
      );
    }

    return false;
  }

  render() {
    let buttonClassName = 'button-popup-form';
    if (!Utils.Helper.isNullOrUndefined(this.props.className)) {
      buttonClassName += this.props.className;
    }
    return (
      <div className={buttonClassName} ref={this.setButtonRef}>
        {this._renderButton()}
        {this._renderDropdown()}
      </div>
    );
  }
}

ButtonTaskDriverTag.displayName = 'Button Task Driver Tag';

ButtonTaskDriverTag.propTypes = {
  buttonClassName: PropTypes.string,
  className: PropTypes.string,
  hint: PropTypes.node,
  iconClassName: PropTypes.string,
  iconText: PropTypes.string,
  id: PropTypes.string,
  isAddingTag: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  setButtonPersistent: PropTypes.func,
  tagMultiple: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.string),
  taskId: PropTypes.number,
  taskIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  // disable eslint for now, maybe we need this props in the future
  // eslint-disable-next-line react/no-unused-prop-types
  text: PropTypes.string,
  textIconClassName: PropTypes.string.isRequired,
};

ButtonTaskDriverTag.defaultProps = {
  buttonClassName: null,
  className: null,
  hint: null,
  iconClassName: null,
  iconText: null,
  id: null,
  onClick: () => {},
  setButtonPersistent: () => {},
  tagMultiple: () => {},
  tags: [],
  taskId: null,
  taskIds: [],
  text: '',
};

export default ButtonTaskDriverTag;
